import { render, staticRenderFns } from "./PopConfirm.vue?vue&type=template&id=055f3fe7&scoped=true&"
import script from "./PopConfirm.vue?vue&type=script&lang=js&"
export * from "./PopConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PopConfirm.vue?vue&type=style&index=0&id=055f3fe7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f3fe7",
  null
  
)

export default component.exports